const PRODUCTION_BASE_URL = "https://api.jak-app.com/";
// const LOCAL_BASE_URL = "https://api.jak-app.com/";
const LOCAL_BASE_URL = "http://localhost:4700/";

const normalizeBaseUrl = (value) => (value.endsWith("/") ? value : `${value}/`);

const configuredBaseUrl =
  process.env.REACT_APP_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? LOCAL_BASE_URL
    : PRODUCTION_BASE_URL);

export const BASE_URL = normalizeBaseUrl(configuredBaseUrl);

export const routes = {
  // -----AUTH------//
  signIn: BASE_URL + "api/v1/user/testLogin",
  logOut: BASE_URL + "api/v1/user/logout",
  getAllUsers: BASE_URL + "api/v1/user/",
  deleteUser: BASE_URL + "api/v1/user",
  updateUser: BASE_URL + "api/v1/user/",
  // deleteUser: BASE_URL + "api/v1/user/deleteMe",
  getAllEmployers: BASE_URL + "api/v1/employer/",
  deleteEmployer: BASE_URL + "api/v1/employer/",
  createEmployer: BASE_URL + "api/v1/employer/create",
  updateEmployer: BASE_URL + "api/v1/employer/",
  getAllEngOffers: BASE_URL + "api/v1/offer/?language=english",
  getAllArabicOffers: BASE_URL + "api/v1/offer/?language=arabic",
  deleteOffer: BASE_URL + "api/v1/offer/",
  createOffer: BASE_URL + "api/v1/offer/create/",
  uploadBulkOffers: BASE_URL + "api/v1/offer/create/bulk",
  getAllEmployerCards: BASE_URL + "api/v1/employer-card/",
  getLoyaltyCards: BASE_URL + "api/v1/loyalty-card",
  deleteEmployerCard: BASE_URL + "api/v1/employer-card/",
  updateEmployerCard: BASE_URL + "api/v1/employer-card/",
  createEmployerCard: BASE_URL + "api/v1/employer-card/create/",
  getAboutUs: BASE_URL + "api/v1/about-us/",
  getTerms: BASE_URL + "api/v1/termsandcondition/",
  getNotificationSettingsOverview:
    BASE_URL + "api/v1/notification-settings/overview",
  getBulkOfferNotificationSetting:
    BASE_URL + "api/v1/notification-settings/bulk-offer",
  updateBulkOfferNotificationSetting:
    BASE_URL + "api/v1/notification-settings/bulk-offer",
  getOffersNotificationTemplate:
    BASE_URL + "api/v1/notification-settings/offers-template",
  updateOffersNotificationTemplate:
    BASE_URL + "api/v1/notification-settings/offers-template",
  getCustomNotificationTemplate:
    BASE_URL + "api/v1/notification-settings/custom-template",
  updateCustomNotificationTemplate:
    BASE_URL + "api/v1/notification-settings/custom-template",
  sendCustomNotification:
    BASE_URL + "api/v1/notification-settings/custom-template/send",
  sendBroadcastNotification:
    BASE_URL + "api/v1/notification-settings/broadcast",
  uploadEngFile: BASE_URL + "api/v1/offer/create/english/",
  uploadArabicFile: BASE_URL + "api/v1/offer/create/arabic/",

  // -----------Products--------------//

  // -------------Services-------------//

  // -------------Services-------------//
};
